// ── Unit Action ───────────────────────────────────────────────────────────────
export const UNIT_ACTIONS_FETCH_STARTED = 'UNIT_ACTIONS_FETCH_STARTED';
export const UNIT_ACTIONS_FETCH_COMPLETED = 'UNIT_ACTIONS_FETCH_COMPLETED';
export const UNIT_ACTIONS_FETCH_FAILED = 'UNIT_ACTIONS_FETCH_FAILED';

export const UNIT_ACTIONS_ADD_STARTED = 'UNIT_ACTIONS_ADD_STARTED';
export const UNIT_ACTIONS_ADD_COMPLETED = 'UNIT_ACTIONS_ADD_COMPLETED';
export const UNIT_ACTIONS_ADD_FAILED = 'UNIT_ACTIONS_ADD_FAILED';

export const UNIT_ACTIONS_EDIT_STARTED = 'UNIT_ACTIONS_EDIT_STARTED';
export const UNIT_ACTIONS_EDIT_COMPLETED = 'UNIT_ACTIONS_EDIT_COMPLETED';
export const UNIT_ACTIONS_EDIT_FAILED = 'UNIT_ACTIONS_EDIT_FAILED';

export const UNIT_ACTIONS_REMOVE_STARTED = 'UNIT_ACTIONS_REMOVE_STARTED';
export const UNIT_ACTIONS_REMOVE_COMPLETED = 'UNIT_ACTIONS_REMOVE_COMPLETED';
export const UNIT_ACTIONS_REMOVE_FAILED = 'UNIT_ACTIONS_REMOVE_FAILED';

// ── Unit Action Configuration ─────────────────────────────────────────────────
export const UNIT_ACTION_CONFIGS_FETCH_STARTED = 'UNIT_ACTION_CONFIGS_FETCH_STARTED';
export const UNIT_ACTION_CONFIGS_FETCH_COMPLETED = 'UNIT_ACTION_CONFIGS_FETCH_COMPLETED';
export const UNIT_ACTION_CONFIGS_FETCH_FAILED = 'UNIT_ACTION_CONFIGS_FETCH_FAILED';

export const UNIT_ACTION_CONFIGS_ADD_STARTED = 'UNIT_ACTION_CONFIGS_ADD_STARTED';
export const UNIT_ACTION_CONFIGS_ADD_COMPLETED = 'UNIT_ACTION_CONFIGS_ADD_COMPLETED';
export const UNIT_ACTION_CONFIGS_ADD_FAILED = 'UNIT_ACTION_CONFIGS_ADD_FAILED';

export const UNIT_ACTION_CONFIGS_EDIT_STARTED = 'UNIT_ACTION_CONFIGS_EDIT_STARTED';
export const UNIT_ACTION_CONFIGS_EDIT_COMPLETED = 'UNIT_ACTION_CONFIGS_EDIT_COMPLETED';
export const UNIT_ACTION_CONFIGS_EDIT_FAILED = 'UNIT_ACTION_CONFIGS_EDIT_FAILED';

export const UNIT_ACTION_CONFIGS_REMOVE_STARTED = 'UNIT_ACTION_CONFIGS_REMOVE_STARTED';
export const UNIT_ACTION_CONFIGS_REMOVE_COMPLETED = 'UNIT_ACTION_CONFIGS_REMOVE_COMPLETED';
export const UNIT_ACTION_CONFIGS_REMOVE_FAILED = 'UNIT_ACTION_CONFIGS_REMOVE_FAILED';


export const PERMISSIONS_FETCH_STARTED = 'UNIT_ACTIONS_PERMISSIONS_FETCH_STARTED';
export const PERMISSIONS_FETCH_COMPLETED = 'UNIT_ACTIONS_PERMISSIONS_FETCH_COMPLETED';
export const PERMISSIONS_FETCH_FAILED = 'UNIT_ACTIONS_PERMISSIONS_FETCH_FAILED';

// ── Interfaces ────────────────────────────────────────────────────────────────
export interface UnitAction {
  unitActionId: number;
  actionName: string;
  icon: string | null;
  parameters: string | null;
  requiresConfirmation: number;
  synchronized: number;
  permissionId: string | null;
  color: string | null;
  fontColor: string | null;
  isConfirmed: boolean;
}

export interface UnitActionConfiguration {
  unitActionConfigurationId: number;
  unitActionId: number;
  deviceModelId: number;
  brandName: string | null;
  deviceModelName: string | null;
  version: number | null;
  description: string | null;
  command: string | null;
  accessLevel: number | null;
  messageType: string | null;
  isConfirmed: boolean;
}
